import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const DisenrollmentReportRedux = createActions(
  {
    DisenrollmentReportRequest: ['start_date', 'end_date'],
    DisenrollmentReportSuccess: ['data', 'fileName'],
    DisenrollmentReportError: ['error'],
    CentersDisenrollmentReportRequest: ['start_date', 'end_date', 'centerId'],
    CentersDisenrollmentReportSuccess: ['data', 'fileName'],
    CentersDisenrollmentReportError: ['error'],
  },
  {
    prefix: 'DISENROLLMENTREPORT_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = DisenrollmentReportRedux
export const DisenrollmentReportTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

/* ------------- Reducers ------------- */

const DisenrollmentReportRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const DisenrollmentReportSuccess = (state, { data, fileName }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  data: { file: data, fileName }
}, d)
const DisenrollmentReportError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

const CentersDisenrollmentReportRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const CentersDisenrollmentReportSuccess = (state, { data, fileName }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  data: { file: data, fileName }
}, d)
const CentersDisenrollmentReportError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.DisenrollmentReportRequest]: DisenrollmentReportRequest,
    [Types.DisenrollmentReportSuccess]: DisenrollmentReportSuccess,
    [Types.DisenrollmentReportError]: DisenrollmentReportError,
    [Types.CentersDisenrollmentReportRequest]: CentersDisenrollmentReportRequest,
    [Types.CentersDisenrollmentReportSuccess]: CentersDisenrollmentReportSuccess,
    [Types.CentersDisenrollmentReportError]: CentersDisenrollmentReportError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/DisenrollmentReportRedux.js